import { ComponentType } from 'react'
import { DatePicker as BaseDatePicker } from 'baseui/datepicker'
import { FormControl } from 'baseui/form-control'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

import useBreakExportForm from './useBreakExportForm'
import { SettingsRow, SettingsSection, SubmitButtonOverrides } from '../styled-components'

const DatePicker = BaseDatePicker as ComponentType<any>

interface BreakExportFormProps {
  hidden: boolean
}

const BreakExportForm = ({ hidden }: BreakExportFormProps) => {
  const { t, startDate, endDate, onStartDateChange, onEndDateChange, rangeError, canSubmit, submit } = useBreakExportForm()

  if (hidden) return null

  return (
    <SettingsSection>
      <SettingsRow>
        <div>
          <FormControl label={t('breakManagement:export.start_date')}>
            <DatePicker id='break-export-start' value={startDate} formatString='dd/MM/yyyy' onChange={onStartDateChange} />
          </FormControl>
        </div>
        <div>
          <FormControl label={t('breakManagement:export.end_date')} error={rangeError}>
            <DatePicker id='break-export-end' value={endDate} formatString='dd/MM/yyyy' onChange={onEndDateChange} />
          </FormControl>
        </div>
      </SettingsRow>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton id='break-export-submit-btn' disabled={!canSubmit} onClick={submit} overrides={SubmitButtonOverrides}>
        {t('breakManagement:export.submit')}
      </SDButton>
    </SettingsSection>
  )
}

export default BreakExportForm
